import { Map } from 'immutable'
import { EN } from 'services/languages/constants'
import { getUserLanguagePrimary } from 'services/user'
import { getAuthIsLoggedIn } from 'services/auth'
import _map from 'lodash/map'
import _get from 'lodash/get'
import {
  getFeaturedEpisodeUserNodeInfo,
  getUserNodeInfoVideoMediaData,
  getMultiplePmUserNodeInfo,
} from 'services/user-node-info/actions'
import {
  SET_EVENT_VIDEO_IMPRESSED,
  SET_EVENT_SERIES_IMPRESSED,
} from 'services/event-tracking/actions'
import { addNewRelicAction } from 'services/app/_newrelic'
import { get as getConfig } from 'config'
import {
  VIDEOS_KEY,
  SERIES_KEY,
  TERM_KEY,
  ACTIONS_SETTINGS_KEY,
} from './entities'
import {
  GET_PM_MULTIPLE_NODES, NODES_RECIEVED, nodesRecieved, nodeImpressed,
} from './actions'
import {
  fetchMultipleNodes as apiGetNodes,
  fetchMultipleTerms as apiGetTerms,
} from './api'
import { isValidNodeId } from './utils'

const config = getConfig()
const tilesV2 = !!_get(config, ['features', 'tilesV2'])

export function fetchMultipleNodesWatcher ({ after }) {
  return after(GET_PM_MULTIPLE_NODES, async ({ action, state, dispatch }) => {
    const { user = Map(), auth = Map() } = state
    const {
      payload: {
        ids,
        key,
        language = getUserLanguagePrimary(user) || EN,
        [ACTIONS_SETTINGS_KEY]: settings,
        // [aburtsev] below is the migragion of hack
        /*
         * fetchAsNodes is a temporary mechanism to switch
         * from using the `/term` endpoint to `/node`
         * The node data structure is our current means of serving content.
         * This gives us access to some data `/term` did not provide.
         * Eventually the plan is to migrate away from `/term` entirely
         * but for now this allows us to still allow pm-lists that use terms
         * to leverage the term part of the store and related code, but with the benefit
         * of the newer 'node' data type.
         */
        fetchAsNodes = false,
        contentType,
      },
    } = action
    // TODO remove this conditionals. It's needed only for safe resolve merge conflicts

    let nodes
    if (key === TERM_KEY) {
      if (fetchAsNodes) {
        nodes = await apiGetNodes(
          {
            ids,
            language,
            auth,
            contentType,
          },
          settings,
        )
      } else {
        nodes = await apiGetTerms(
          {
            ids,
            language,
            auth,
          },
          settings,
        )
      }
    } else {
      nodes = await apiGetNodes(
        {
          ids,
          language,
          auth,
        },
        settings,
      )
    }

    if (getAuthIsLoggedIn(auth)) {
      dispatch(getMultiplePmUserNodeInfo(ids))
      // when we are getting series nodes, we also need to grab the featured episode info now
      // so that we can show the continue watching episode (all series tiles should going forward)
      // IMO this should be refactored to happen in brooklyn and come back with the batchget req
      // but apps is already using this secondary endpoint so we are going with this implementation
      // for now
      if (key === 'series') {
        dispatch(getFeaturedEpisodeUserNodeInfo(ids))
      }

      // when we are getting the video/episode nodes, we need to grab the media data as well
      if (key === 'video' && tilesV2) {
        const nodeMediaData = _map(nodes, (node) => {
          return {
            id: _get(node, ['data', 'nid'], null),
            mediaId: _get(node, ['data', 'feature', 'nid'], null),
          }
        })

        dispatch(getUserNodeInfoVideoMediaData(nodeMediaData))
      }
    }

    dispatch(nodesRecieved({ key, nodes, language }))
  })
}

export function videoNodeImpressedWatcher ({ takeEvery }) {
  return takeEvery(SET_EVENT_VIDEO_IMPRESSED, ({ action }) => {
    const { event, language } = action.payload
    const id = event.getIn(['contentId'])
    return nodeImpressed({
      key: VIDEOS_KEY,
      id,
      language: language.get(0),
    })
  })
}

export function seriesNodeImpressedWatcher ({ takeEvery }) {
  return takeEvery(SET_EVENT_SERIES_IMPRESSED, ({ action }) => {
    const { event, language } = action.payload
    const id = event.getIn(['contentId'])

    return nodeImpressed({
      key: SERIES_KEY,
      id,
      language: language.get(0),
    })
  })
}

export function watchInvalidNodeRecieved ({ after }) {
  return after(NODES_RECIEVED, ({ action }) => {
    const { nodes, language } = action.payload
    nodes.forEach((node) => {
      const nodeId = node.id
      if (!isValidNodeId(nodeId)) {
        addNewRelicAction('InvalidNodeRecieved', {
          recievedId: nodeId,
          language,
          msg: 'node should contain valid id',
        })
      }
    })
  })
}
